import React, { useState, useContext, useEffect } from 'react';
import './Membership.css';
import { useNavigate } from 'react-router-dom';
import { StateContext } from '../../../../StateProvider';
import { BackButton } from '../../../../Utilities/components/Buttons';

// 🐾 Updated Membership Benefits — Club vs Plus
var membershipBenefits = {
  Club: [
    "Member Savings: 10%",
    "Concierge & Text Support",
    "Daily Feeding (Standard)",
    "Health & Grooming Check",
    "Daycare Report Card",
    "Exclusive Member Events"
  ],
  Plus: [
    "Member Savings: 20%",
    "Top-Priority Booking",
    "Concierge & Text Support",
    "Premium Daily (Premium)",
    "Health & Grooming Check",
    "Daycare Report Card",
    "Exclusive Member Events",
    "Birthday Treat Box (1 / yr)",
    "Nail Trim & Teeth Brushing"
  ]
};

function Membership() {
  var navigate = useNavigate();
  var context = useContext(StateContext);
  var user = context.user;
  var setBookingData = context.setBookingData;
  var [userMemberships, setUserMemberships] = useState([]);

  useEffect(function () {
    if (user) {
      if (user.clubMembership) {
        setUserMemberships([user.clubMembership]);
      } else if (user.ClubMemberships && user.ClubMemberships.length > 0) {
        setUserMemberships(user.ClubMemberships);
      } else if (user.Memberships && user.Memberships.length > 0) {
        setUserMemberships(user.Memberships);
      } else {
        setUserMemberships([]);
      }
    }
  }, [user]);

  function handleEditMembership(membership) {
    window.scrollTo(0, 0);
    navigate('/profile/membership/update/' + membership.id);
  }

  function handleEnrollMembership() {
    setBookingData(function (prevData) {
      var updated = {};
      for (var key in prevData) updated[key] = prevData[key];
      updated.bookingType = 'store/membership';
      return updated;
    });
    localStorage.setItem('bookingType', 'store/membership');
    window.scrollTo(0, 0);
    navigate('/store/membership');
  }

  if (!user) return null;

  var hasMembership = userMemberships.length > 0;
  var activeMembership = hasMembership ? userMemberships[0] : null;
  var isCancelled = activeMembership && activeMembership.cancelledAt;

  return (
    <div className="container">
      <BackButton />

      <div className="membership-user-section">
        <div className="membership-family-member">
          <div className="membership-family-member-details">
            <img
              className='membership-family-member-image'
              src={user.image}
              alt={user.username || 'User'}
            />
            <div>
              <h3 className='membership-family-member-name'>
                {user.username || 'Guest'}
              </h3>
              <p className='membership-family-member-type'>Owner</p>
            </div>

            <div className="badges-container">
              {!hasMembership ? (
                <span className="badge membership-unverified">No Membership</span>
              ) : isCancelled ? (
                <span className="badge membership-cancelled">Membership Cancelled</span>
              ) : (
                <span className="badge membership-verified">Active Member</span>
              )}
            </div>
          </div>

          {hasMembership ? (
            isCancelled ? (
              <div className='membership-tier-details'>
                <h4 className='membership-tier-header'>
                  {formatMembershipTitle(activeMembership.planType)}
                </h4>
                {activeMembership.billingStatus ? (
                  <p className='membership-status'>
                    Status: <strong>{activeMembership.billingStatus}</strong>
                  </p>
                ) : null}
                <p className='membership-tier-nextBilling'>
                  Deactivated: {new Date(activeMembership.cancelledAt).toLocaleDateString()}
                </p>
              </div>
            ) : (
              renderMembershipDetails(activeMembership)
            )
          ) : null}

          <div className="membership-actions">
            {!hasMembership || isCancelled ? (
              <button
                className='membership-renew-button'
                onClick={handleEnrollMembership}
              >
                Enroll
              </button>
            ) : (
              <button
                className='membership-update-button'
                onClick={function () {
                  handleEditMembership(activeMembership);
                }}
              >
                Manage Membership
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Membership;

// Helper to clean membership type name
function getTruncatedMembershipType(type) {
  if (!type || type.indexOf(" ") === -1) return type;
  return type.split(" ").pop().trim();
}

// Render membership details dynamically
function renderMembershipDetails(membership) {
  if (!membership) return null;

  var membershipType = membership.membershipType || membership.planType || 'Membership';
  var truncatedType = getTruncatedMembershipType(membershipType);
  var benefits = membershipBenefits[truncatedType] || membership.perks || [];

  return (
    <div className='membership-tier-details'>
      {membership.startDate ? (
        <p className='membership-tier-startDate'>
          Since {new Date(membership.startDate).toLocaleDateString()}
        </p>
      ) : null}

      <h4 className='membership-tier-header'>
        {formatMembershipTitle(membershipType)}
      </h4>

      <ul>
        {benefits.map(function (benefit, index) {
          return (
            <li key={index} className='membership-tier-li'>{benefit}</li>
          );
        })}
      </ul>

      {membership.billingStatus ? (
        <p className='membership-status'>
          Status: <strong>{membership.billingStatus}</strong>
        </p>
      ) : null}

      {membership.cancelledAt ? (
        <p className='membership-tier-nextBilling'>
          Deactivated: {new Date(membership.cancelledAt).toLocaleDateString()}
        </p>
      ) : membership.nextBillingDate ? (
        <p className='membership-tier-nextBilling'>
          Next Billing: {new Date(membership.nextBillingDate).toLocaleDateString()}
        </p>
      ) : null}
    </div>
  );
}

function formatMembershipTitle(type) {
  if (!type) return 'Membership';

  var lower = type.toLowerCase();
  if (lower.indexOf('pawsible') !== -1) return type;
  if (lower === 'club') return 'Pawsible Club';
  if (lower === 'plus') return 'Pawsible Plus Club';
  return 'Pawsible ' + type;
}
